import axios from "axios";
import { MedicalShipmentProto } from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/medical_shipments_service";

import { HEALTHCARE_API } from "@modules/common/constants";

export const getShippingData = async (
  accessCode: string,
  accessToken: string,
  userTreatmentId?: string | null
): Promise<MedicalShipmentProto> => {
  return (
    await axios.get<MedicalShipmentProto>(
      `${HEALTHCARE_API}/v1/patient/${accessCode}/next_shipment`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
        params: userTreatmentId
          ? { user_treatment_id: userTreatmentId }
          : undefined,
      }
    )
  ).data;
};